import { inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { HistoryComponent } from '@app/pages/books/pages/history/history.component';
import { AlertConfigModel, ConfirmAlertComponent, EConfirmButton } from '@shared/components/confirm-alert/confirm-alert.component';
import { DRAFT_KEY, DraftModel, IHistoryDraftTemp } from '@shared/helper/draft/models/draft.model';


export const progressGuard: CanDeactivateFn<HistoryComponent> = (component: HistoryComponent):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const dialog: MatDialog = inject(MatDialog);
  const bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  const localRepository: LocalRepository = inject(LocalRepository);

  const dialogInfo: AlertConfigModel = {
    cancelButtonText: 'بله می‌روم',
    confirmButtonText: 'خیر ادامه می‌دهم',
    title: 'می‌خواهید به صفحۀ دیگری بروید؟',
  };

  if (!!(component?.progress?.body) || component?.progress?.steps > component?.book?.mySteps?.steps!) {
    if (localRepository.IsInMobile) {
      const bottomSheetRef = bottomSheet.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-bottomsheet'
      });

      return bottomSheetRef.afterDismissed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    } else {
      const dialogRef = dialog.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-dialog'
      });

      return dialogRef.afterClosed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    }
  }
  return of(true);
};

function handleAction(action: EConfirmButton, component: HistoryComponent, localRepository: LocalRepository): boolean {
  if (action === EConfirmButton.CANCLE) {
    const existData: DraftModel = JSON.parse(localRepository.getLocalItem(DRAFT_KEY)!) || new DraftModel();
    const existDraftHistory = existData?.history?.data?.findIndex(draft => draft.bookId === component.bookId);
    const draftHistory: IHistoryDraftTemp = {
      body: component.progress.body,
      bookId: component.bookId,
      pageNumber: component.progress.steps,
    };

    if (existDraftHistory! >= 0) {
      existData.history!.data[existDraftHistory!] = draftHistory;
    } else {
      if (!existData.history) {
        existData.history = { draftKey: 'history', data: [] };
      }
      existData.history.data.push(draftHistory);
    }
    localRepository.setLocalItem(DRAFT_KEY, JSON.stringify(existData));
    return true;
  } else if (action === EConfirmButton.CONFIRM) {
    return false;
  } else {
    return false;
  }
}
